import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Row, Card } from "react-bootstrap";
import {
  getFacilityBuildingRooms,
  deleteFacilityBuildingRoom,
} from "../../../../services/FacilityBuildingRoomService";

const FacilityBuildingRoomList = () => {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    getFacilityBuildingRooms()
      .then((data) => setRooms(data))
      .catch((error) => console.error(error));
  }, []);

  const onDelete = (id) => {
    deleteFacilityBuildingRoom(id)
      .then(() => setRooms(rooms.filter((room) => room._id !== id)))
      .catch((error) => console.error(error));
  };

  return (
    <div>
      <Card>
      <h2 style={{color:"black"}}>Facility Building Rooms</h2>
      <div className="d-flex justify-content-end">
      <Link to="/settings/fbr/add">
        <Button variant="primary" className="mb-3">
          Add Room
        </Button>
        
      </Link>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Label</th>
            <th>Value</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rooms.map((room) => (
            <tr key={room._id}>
              <td>{room.label}</td>
              <td>{room.value}</td>
              <td>
                <Link to={`/settings/fbr/edit/${room._id}`}>
                  <Button
                    variant="warning"
                    title="View"
                    className="btn btn-primary shadow btn-xs sharp me-1"
                    style={{background:"#3a7afe", border:"none"}}
                   
                  >
                    <i className="fa fa-pencil"></i>
                  </Button>
                </Link>{" "}
                <Button
                  onClick={() => onDelete(room._id)}
                  title="Delete"
                  className="btn btn-danger shadow btn-xs sharp"
                  
                >
                  <i className="fa fa-trash"></i>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      </Card>
    </div>
  );
};

export default FacilityBuildingRoomList;
